import {Navigate, useRoutes} from "react-router-dom"
import AuthGuard from "../auth/AuthGuard"
import GuestGuard from "../auth/GuestGuard"
import CompactLayout from "../layouts/compact"
import DashboardLayout from "../layouts/dashboard"
import {
    LoginPage,
    Page404,
    PageBuses,
    PageDashboard,
    PageMap,
    PageReports,
    PageRoutes,
    PageSettings,
    PageDrivers,
    PageDriverCreate,
    PageDriverEdit,
    PageBusCreate,
    PageBusEdit,
    PageReportByBus,
    PageRouteCreate,
    PageReportByDay,
    PageRouteEdit,
    DeleteAccountPage,
    PageMainStation,
    PageStations,
    PageStationCreate,
    PageStationEdit,
    PageMira, PageScheduleConfiguration, PageScheduleCreate
} from "./elements"
import {PATH_BUS_STATION, PATH_DASHBOARD, PATH_DELETE_ACCOUNT} from "./paths"
import RequestLayout from "../layouts/request"
import StationLayout from "../layouts/station"

export default function Router() {
    return useRoutes([
        {
            path: "/",
            children: [
                {element: <Navigate to="login" replace />, index: true},
                {
                    path: "login",
                    element: (
                        <GuestGuard>
                            <LoginPage />
                        </GuestGuard>
                    )
                }
            ]
        },
        {
            path: "/",
            element: <RequestLayout />,
            children: [
                {element: <Navigate to={PATH_DELETE_ACCOUNT.delete} replace/>, index: true},
                {path: "delete-account", element: <DeleteAccountPage />}
            ]
        },
        {
            path: "/",
            element: <StationLayout />,
            children: [
                {element: <Navigate to={PATH_BUS_STATION.station} replace/>, index: true},
                {path: "station", element: <PageMainStation />}
            ]
        },

        {
            path: "/dashboard",
            element: (
                <AuthGuard>
                    <DashboardLayout />
                </AuthGuard>
            ),
            children: [
                {element: <Navigate to={PATH_DASHBOARD.departure} replace />, index: true},
                {path: "departure", element: <PageDashboard />},
                {path: "map", element: <PageMap />},
                {path: "mira", element: <PageMira />},
                {
                    path: "stations",
                    children: [
                        {element: <PageStations />, index: true},
                        {path: "new", element: <PageStationCreate />},
                        {path: ":id/edit", element: <PageStationEdit />}
                    ]

                },
                {
                    path: "drivers",
                    children: [
                        {element: <PageDrivers />, index: true},
                        {path: "new", element: <PageDriverCreate />},
                        {path: ":id/edit", element: <PageDriverEdit />}
                    ]
                },
                {
                    path: "buses",
                    children: [
                        {element: <PageBuses />, index: true},
                        {path: "new", element: <PageBusCreate />},
                        {path: ":id/edit", element: <PageBusEdit />}
                    ]
                },
                {
                    path: "schedule",
                    children: [
                        {element: <Navigate to="/dashboard/schedule/configuration" replace />, index: true},
                        {path: "configuration", element: <PageScheduleConfiguration />},
                        {path: "new", element: <PageScheduleCreate />},
                    ]
                },
                {
                    path: "routes",
                    children: [
                        {element: <PageRoutes />, index: true},
                        {path: "new", element: <PageRouteCreate />},
                        {path: ":id/edit", element: <PageRouteEdit />}
                    ]
                },
                {
                    path: "reports",
                    children: [
                        {element: <Navigate to="/dashboard/reports/historical" replace />, index: true},
                        {path: "historical", element: <PageReports />},
                        {path: "day", element: <PageReportByDay />},
                        {path: "bus", element: <PageReportByBus />},
                    ]
                },
                {path: "settings", element: <PageSettings />}
            ]
        },
        {
            element: <CompactLayout />,
            children: [{path: "404", element: <Page404 />}]
        },
        {path: "*", element: <Navigate to="/404" replace />}
    ])
}